module.exports = __webpack_public_path__ + "assets/a9885e9742060dc6885240eb4b570b0d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/anticipate/LongerSpin.mp3
 ** module id = 466
 ** module chunks = 0
 **/